import { rootUrl } from './shared';
export const generateBreadcrumbScheme = (list, path) => {
  const pageUrl = (rootUrl + path).toLocaleLowerCase();
  const itemList = list.map((i, index) => {
    const id = rootUrl + i.href;
    return {
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'WebPage',
        id,
        url: id,
        name: i.name
      }
    };
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${pageUrl}#breadcrumb`,
    itemListElement: itemList
  };
};

export const breadcrumbDataToSchemaScript = (list, path) =>
  JSON.stringify(generateBreadcrumbScheme(list, path));
